import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { supabase } from '@/integrations/supabase/client';

let sessionId: string | null = null;

// Generate a session ID once per browser session
const getSessionId = () => {
  if (!sessionId) {
    sessionId = `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
  }
  return sessionId;
};

export const usePageViewTracking = () => {
  const location = useLocation();

  useEffect(() => {
    const trackPageView = async () => {
      try {
        console.log('📍 Page view tracking triggered for:', location.pathname);
        
        const { data: { session } } = await supabase.auth.getSession();
        
        console.log('🔐 Auth session check:', { 
          hasSession: !!session, 
          userId: session?.user?.id || 'none'
        });
        
        if (!session) {
          console.log('⚠️ No session - page view not tracked');
          return;
        }

        // Get page title from document
        const pageTitle = document.title;
        const sessionId = getSessionId();

        console.log('📊 Logging page view:', {
          page_path: location.pathname,
          page_title: pageTitle,
          session_id: sessionId,
          user_id: session.user.id
        });

        // Log the page view
        const { data, error } = await supabase.functions.invoke('audit-page-view', {
          body: {
            page_path: location.pathname,
            page_title: pageTitle,
            session_id: sessionId
          },
          headers: {
            Authorization: `Bearer ${session.access_token}`
          }
        });

        if (error) {
          console.error('❌ Page view tracking error:', error);
        } else {
          console.log('✅ Page view tracked successfully:', data);
        }
      } catch (error) {
        console.error('❌ Failed to track page view:', error);
        // Don't throw error to avoid disrupting the main flow
      }
    };

    trackPageView();
  }, [location.pathname]);
};
